import {Inject, Injectable} from '@angular/core';
import {ApiResourceLocation, ResourceService, SOFTLINE_SERVICE_HTTP} from '@softline/core';
import {Observable} from 'rxjs';
import {Pruefprotokoll} from '../types/pruefprotokoll';
import {SOFTLINE_API_PRUEFPROTOKOLL, SOFTLINE_API_PRUEFPROTOKOLL_LAGERPLATZ_SCAN} from '../pruefprotokoll.api';

@Injectable()
export class PruefprotokollService {

  constructor(
    @Inject(SOFTLINE_SERVICE_HTTP) private httpService: ResourceService<ApiResourceLocation>
  ) {}

  aufzeichnen(payload: Partial<Pruefprotokoll>): Observable<Pruefprotokoll> {
    return this.httpService.create({ path: SOFTLINE_API_PRUEFPROTOKOLL }, payload);
  }

  getLagerplatz(code: string): Observable<object> {
    return this.httpService.get({
      path: SOFTLINE_API_PRUEFPROTOKOLL_LAGERPLATZ_SCAN,
      pathParams: { code }
    })
  }
}
